// extracted by mini-css-extract-plugin
module.exports = {"container":"CancellationModal_container__2WPqm","float_right":"CancellationModal_float_right__1br_f"};